import { CalendarHolidaysRepository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: CalendarHolidaysRepository): Interactor {
  return ({ planzone, calendarHolidays }) =>
    present(
      repository
        .saveCalendarHolidays(planzone, calendarHolidays)
        .then((savedCalendarHolidays) => ({
          planzone,
          calendarHolidays: savedCalendarHolidays,
        }))
        .catch(() =>
          Promise.reject({
            planzone,
            calendarHolidays,
          }),
        ),
    );
}

export type { Interactor };

export { createInteractor };
